<template lang="html">
  <div style="margin: 0px -12px -12px; padding: 0px 12px 12px; background-color: #fff;">
    <div>
      <div v-for="idx in (isFirst ? 6 : 2)" :key="idx" class="custom-skeleton-list">
        <div class="custom-skeleton-list-image">
          <v-skeleton-loader v-bind="attrs" type="image" />
        </div>
        <div class="custom-skeleton-list-content">
          <div class="custom-skeleton-list-text">
            <v-skeleton-loader v-bind="attrs" type="list-item-three-line" />
          </div>
        </div>
        <div class="custom-skeleton-list-action">
          <v-skeleton-loader v-bind="attrs" type="list-item-two-line" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CustomSkeletonList',
  props: {
    isFirst: {
      default: true,
      type: Boolean
    }
  }
}
</script>
